module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro",
      "id": "tocintro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01",
      "id": "tocch01"
    }
  }, [_vm._v("“A "), _c('em', [_vm._v("Stranger")]), _vm._v(" Amongst "), _c('em', [_vm._v("Strangers")]), _vm._v("”: Who Were the Subassistant Commissioners?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "id": "tocch02"
    }
  }, [_vm._v("“The Post of Greatest Peril”: The E. M. Gregory Era, September 1865–April 1866")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "id": "tocch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conservative Phoenix: The J. B. Kiddoo Era, May 1866–Summer 1866")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "id": "tocch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bureau Expansion, Bureau Courts, and the Black Code: The J. B. Kiddoo Era, Summer 1866–November 1866")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "id": "tocch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bureau’s Highwater Mark: The J. B. Kiddoo Era, November 1866–January 1867")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "id": "tocch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“They Must Vote with the Party That Shed Their Blood . . . In Giving Them Liberty.” Bureau Agents, Politics, and the Bureau’s New Order: The Charles Griffin Era, January 1867–Summer 1867")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "id": "tocch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Violence, Frustration, and Yellow Fever: The Charles Griffin Era, Summer–Fall 1867")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "id": "tocch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Orders No. 40 and the Freedmen’s Bureau’s End: The J. J. Reynolds Era, September 1867–December 1868")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/conclu#conclu",
      "id": "tocconclu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Subassistant Commissioners in Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/app01#app01",
      "id": "tocapp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix A")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/app02#app02",
      "id": "tocapp02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix B")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#notes",
      "id": "tocnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "id": "tocbib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "id": "tocindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0